import { identity, prop } from 'ramda'
import { unified } from 'unified'
import remarkParse from 'remark-parse'

const EMPTY_LINE_CODE = 'EMPTY_LINE'
const HEADER_CODE = 'HEAEDER_CODE'
const QUOTE_CODE = 'QUOTE_CODE'

export const deserializeMarkdown = value => {
  if (!value || value === '' || value === '\n') return [{ type: 'paragraph', children: [{ text: '' }] }]
  const formattedValue = hideUnsupportedMarks(value)
  const ast = unified().use(remarkParse).parse(formattedValue)
  return ast.children.flatMap(formatElement)
}

const hideUnsupportedMarks = value =>
  value
    .replace(/\n\s*\n/g, `\n\n${EMPTY_LINE_CODE}\n\n`)
    .replace('#', HEADER_CODE)
    .replace('> ', QUOTE_CODE)

const restoreUnsupportedMarks = value =>
  value //
    .replace(HEADER_CODE, '#')
    .replace(QUOTE_CODE, '> ')

const formatElement = (node, parentMarkers) => {
  switch (node.type) {
    case 'paragraph':
      return { type: 'paragraph', children: formatElements(node.children) }
    case 'list':
      const type = node.ordered ? 'numered_list' : 'list'
      return { type, children: formatElements(node.children) }
    case 'listItem':
      let children = node.children
      if (!children || !children.length) children = [{ type: 'text', value: '' }]
      return { type: 'list_item', children: formatElements(children) }
    case 'image':
      return { type: 'image', url: node.url, alt: node.alt, children: [{ text: '' }] }
    case 'link':
      return { type: 'link', url: node.url, children: formatElements(node.children) }
    case 'strong':
      return formatElements(node.children, { bold: true })
    case 'emphasis':
      return formatElements(node.children, { italic: true })
    case 'thematicBreak':
      return { text: '' }
    case 'text':
      if (node.value?.trim() === EMPTY_LINE_CODE) {
        return { text: '' }
      } else {
        return { text: restoreUnsupportedMarks(node.value), ...parentMarkers }
      }
    default:
      if (!!node.children) return formatElements(node.children)
      if (!!node.value) {
        return { text: restoreUnsupportedMarks(node.value), ...parentMarkers }
      }
      return null
  }
}

const formatElements = (nodes, markers) => {
  //nodes?.map(item => console.log(item, markers))
  return nodes?.flatMap(item => formatElement(item, markers)).filter(identity)
}
